import { useEffect, useRef, useState } from 'react';
import {
  Button,
  SearchBar,
  SearchIcon,
  Loading,
  InfiniteScroll,
} from '@trufla-technology/trumarket-react-design-system';
import { SortingLine } from 'app/components/SortingLine/index';
import { BranchCard } from './BranchCard/BranchCard';
import { useListLocations } from '@trufla-technology/trufla-trudomain/dist/lib/truMarket';
import { debounce } from 'lodash';
import { useHistory } from 'react-router-dom';
import { useAuthContext } from '@trufla-technology/trufla-trudomain/dist/lib';
import { ListLocationsResponse } from '@trufla-technology/trufla-trudomain/dist/lib/truMarket/types';

export const CompanyBranches = () => {
  const { isPermitted } = useAuthContext();
  const [branches, setBranches] = useState<ListLocationsResponse['data']>([]);
  const {
    data,
    paging,
    loading,
    handleSort,
    handleFilter,
    handleOffset,
    get,
    sortIndex,
    query,
  } = useListLocations({
    paginate: { limit: 40, offset: 0 },
  });
  const history = useHistory();

  useEffect(() => {
    if (!data?.length) {
      return;
    }
    if (
      branches?.length! < query.paginate?.offset! + paging?.limit! &&
      branches?.length! < paging?.count!
    ) {
      setBranches([...branches!, ...data]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  const loadMore = () => {
    handleOffset(query.paginate?.limit! + query.paginate?.offset!);
  };

  const debouncedSearch = useRef(
    debounce((searchValue) => {
      setBranches([]);
      handleFilter({
        name: searchValue.length > 0 ? searchValue : undefined,
      });
    }, 600),
  ).current;
  useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);

  return (
    <div className="">
      <div className="header">
        <p>Branches {paging?.count ? `(${paging?.count})` : ''}</p>
        {isPermitted('createLocation') && (
          <Button
            onClick={() =>
              history.push('/configurations/company-details/create-branch')
            }
            type="primary"
          >
            Add Branch
          </Button>
        )}
      </div>
      <div className="search-sorting-bar">
        <SearchBar
          placeholder="Filter"
          onSearch={(e: string) => {
            debouncedSearch(e);
          }}
          isSecondary
          icon={<SearchIcon fill="var(--tru-grey)" />}
        />
        <div>
          <SortingLine
            items={[
              { key: 'name', label: 'Name' },
              { key: 'createdAt', label: 'Created' },
            ]}
            onChange={(e: any) => {
              setBranches([]);
              handleSort(e);
            }}
            sortingIndex={{
              key: Object.keys(sortIndex)[0],
              label: Object.values(sortIndex)[0] as string,
            }}
          />
        </div>
      </div>
      <div className="branches-list-scroll">
        {loading && branches?.length === 0 ? (
          <div className="loading-branches">
            <Loading />
          </div>
        ) : (
          <div className="branches-list">
            <InfiniteScroll
              data={branches!}
              hasMore={!!!(branches?.length! >= paging?.count!)}
              height="66vh"
              itemContent={(_index, branch) => {
                return (
                  <BranchCard
                    key={branch.key}
                    data={branch}
                    getBranches={get}
                  />
                );
              }}
              loadMore={loadMore}
              emptyPlaceHolder={
                <div className="empty-branches">No Branches Found</div>
              }
            />
            {loading && branches?.length && (
              <div className="loading-wrapper">
                <Loading />
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};
